import commonModalCSS from '@assets/css/common-modal.css';

/**
 * Common modal styles.
 * @type {CSSStyleSheet}
 */
export const commonModalStyles = new CSSStyleSheet();
commonModalStyles.replaceSync(commonModalCSS);
